// extracted by mini-css-extract-plugin
export default {"link":"menu_link__Q0jVp","avatar":"menu_avatar__AcR-S","online":"menu_online__Gmnst","status":"menu_status__n6GJN"};